import store from '../';
import config from '@/config';
import util from './utils';
import {
  AJAX_ERROR,
  AJAX_LOADING
} from '../mutation-types';

export function formatMsg(msg) {
  const nim = store.state.nim;
  if (msg.type === 'robot') {
    if (msg.content && msg.content.flag === 'bot') {
      if (msg.content.message) {
        msg.content.message = msg.content.message.map((item) => {
          switch (item.type) {
            case 'template':
              item.content = nim.parseRobotTemplate(item.content);
              break;
            case 'text':
            case 'image':
            case 'answer':
              break;
          }
          return item;
        });
      }
    }
  }
  return msg;
}

export function onRoamingMsgs(obj) {
  const msgs = obj.msgs.map((msg) => {
    return formatMsg(msg);
  });
  store.commit('updateMsgs', msgs);
}

export function onOfflineMsgs(obj) {
  const msgs = obj.msgs.map((msg) => {
    return formatMsg(msg);
  });
  store.commit('updateMsgs', msgs);
}

export function onMsg(msg) {
  msg = formatMsg(msg);
  store.commit('putMsg', msg);
  if (msg.sessionId === store.state.currSessionId) {
    store.commit('updateCurrSessionMsgs', {
      type: 'put',
      msg
    });
      // 发送已读回执
    store.dispatch('sendMsgReceipt');
  }
  if (msg.scene === 'team' && msg.type === 'notification') {
    store.dispatch('onTeamNotificationMsg', msg);
  }
}

function onSendMsgDone(error, msg) {
  //store.dispatch('hideLoading');
  if (error) {
      // 被拉黑
    if (error.code === 7101) {
      msg.status = 'success';
      alert(error.message);
    } else {
      alert(error.message);
    }
  }
  onMsg(msg);
}


// 消息撤回
export function onRevocateMsg(error, msg) {
  const nim = store.state.nim;
  if (error) {
    if (error.code === 508) {
      alert('发送时间超过2分钟的消息，不能被撤回');
    } else {
      alert(error);
    }
    return;
  }
  let tip = '';
  if (msg.from === store.state.userUID) {
    tip = '你撤回了一条消息';
  } else {
    const userInfo = store.state.userInfos[msg.from];
    if (userInfo) {
      tip = `${util.getFriendAlias(userInfo)}撤回了一条消息`;
    } else {
      tip = '对方撤回了一条消息';
    }
  }
  nim.sendTipMsg({
    isLocal: true,
    scene: msg.scene,
    to: msg.to,
    tip,
    time: msg.time,
    done: function sendTipMsgDone(error, tipMsg) {
      const idClient = msg.deletedIdClient || msg.idClient;
      store.commit('replaceMsg', {
        sessionId: msg.sessionId,
        idClient,
        msg: tipMsg
      });
      if (msg.sessionId === store.state.currSessionId) {
        store.commit('updateCurrSessionMsgs', {
          type: 'replace',
          idClient,
          msg: tipMsg
        });
      }
    }
  });
}


export function revocateMsg({ state, commit }, msg) {
  const nim = state.nim;
  const { idClient } = msg;
  msg = Object.assign(msg, state.msgsMap[idClient]);
  nim.deleteMsg({
    msg,
    done: function deleteMsgDone(error) {
      onRevocateMsg(error, msg);
    }
  });
}
export function updateLocalMsg({ state, commit }, msg) {
  store.commit('updateCurrSessionMsgs', {
    type: 'replace',
    idClient: msg.idClient,
    msg
  });
  state.nim.updateLocalMsg({
    idClient: msg.idClient,
    localCustom: msg.localCustom
  });
  store.commit('replaceMsg', {
    sessionId: msg.sessionId,
    idClient: msg.idClient,
    msg
  });
}


/**
 * msgType: 0-系统消息 1-图片 2-音频 3- 视频 4-时间消息 5-普通文字消息 6-图文消息.
 * to: 消息接收人
 * text: 消息内容，仅系统消息、时间消息、普通文字消息有值
 * url: 图片或者音频消息的地址
 * dur: 音频文件播放时间
 * scene: 场景 群聊还是点对点.
 * expertId: 专家id.
 * uid: 用户encUserId.
 * fileInput 文件流,上传文件专用
 * questionId：问题id
 * @param {*} param0 
 * @param {*} formatMsg  
 */
export function sendFormatMsg({ state, commit }, formatMsg){
  const { msgType, to, text, url, dur, fileInput, questionId, scene, expertId, uid} = formatMsg;
  let obj = {};
  obj.scene = scene;
  obj.custom = {
    questionType: 1,
    objectType: 1,
    roleType: 1,
    questionId:  parseInt(questionId),
    expertId: parseInt(expertId),
    uid: uid,
    visibleType: 1 
  }
  obj.pushContent = '您咨询的专家有新回复啦';
  obj.pushPayload = {
    v2u: `bbtsp://com.stardoctor.patient/xx_platform/message_list?questionId=${questionId}`
  }
  obj.to = to;
  if(msgType === 1){//图片消息.
     //obj.type = 'file';
     obj.fileInput = fileInput;
     obj.custom.msgType = 2;
     return sendFileMsg({ state, commit },obj);
  }else if(msgType === 2){//音频消息.
    obj.type = 'custom';
    obj.content = { url:url, dur: parseInt(dur),msgType: 26 };
    obj.custom.msgType = 26;
    return sendMsg({ state, commit },obj);
  }else if(msgType === 5){
    obj.type = 'text';
    obj.text = text;
    obj.custom.msgType = 1;
    return sendMsg({ state, commit },obj);
  }
}


  // 发送普通消息
export function sendMsg({ state, commit }, obj) {
  return new Promise(function(resolve,reject){
    const nim = state.nim;
    obj = obj || {};
    const type = obj.type || '';
    //store.dispatch('showLoading');
    switch (type) {
      case 'text':
        nim.sendText({
          scene: obj.scene,
          to: obj.to,
          text: obj.text,
          pushContent: obj.pushContent,
          pushPayload: JSON.stringify(obj.pushPayload),
          done: function(error,msg){
            onSendMsgDone(error,msg);
            if(error){
              reject(error);
            }else{
              resolve(msg);
            }
          },
          custom: JSON.stringify(obj.custom),
          needMsgReceipt: obj.needMsgReceipt || false
        });
        break;
      case 'custom':
        nim.sendCustomMsg({
          scene: obj.scene,
          to: obj.to,
          pushContent: obj.pushContent,
          pushPayload: JSON.stringify(obj.pushPayload),
          custom: JSON.stringify(obj.custom),
          content: JSON.stringify(obj.content),
          done: function(error,msg){
            onSendMsgDone(error,msg);
            if(error){
              reject(error);
            }else{
              resolve(msg);
            }
          },
        });
    }
  });
}
//  消息发送失败,重新发送消息
export function resendMsg({ state, commit },msg){
  const nim = state.nim;
  nim.resendMsg({
    msg: msg,
    done: onSendMsgDone
  })
}

  // 发送文件消息
export function sendFileMsg({ state, commit }, obj) {
  return new Promise(function(resolve,reject){
    const nim = state.nim;
    commit(AJAX_LOADING, { loadingStatus: true });
    let { type, fileInput, custom, pushPayload } = obj;
    if (!type) {
      type = 'file';
      if (/\.(png|jpg|bmp|jpeg|gif)$/i.test(fileInput.value)) {
        type = 'image';
      } else if (/\.(mov|mp4|ogg|webm)$/i.test(fileInput.value)) {
        type = 'video';
      }
    }
    if( custom ){
      obj.custom = JSON.stringify(obj.custom);
    }
    if(pushPayload){
      obj.pushPayload = JSON.stringify(obj.pushPayload)
    }
    //store.dispatch('showLoading');
    const data = Object.assign({
      type,
      uploadprogress(data) {
          // console.log(data.percentageText)
      },
      uploaderror() {
        fileInput.value = '';
        console && console.log('上传失败');
        commit(AJAX_LOADING, { loadingStatus: false });
        commit(AJAX_ERROR, new Error('上传失败'));
      },
      uploaddone(error, file) {
        fileInput.value = '';
        commit(AJAX_LOADING, { loadingStatus: false });
          // console.log(error);
          // console.log(file);
      },
      beforesend(msg) {
          // console && console.log('正在发送消息, id=', msg);
      },
      done(error, msg) {
        onSendMsgDone(error, msg);
        if(error){
          reject(error);
        }else{
          resolve(msg);
        }
        commit(AJAX_LOADING, { loadingStatus: false });
      }
    }, obj);
    nim.sendFile(data);
  }); 
  
}

  // 发送机器人消息
export function sendRobotMsg({ state, commit }, obj) {
  const nim = state.nim;
  let { type, scene, to, robotAccid, content, params, target, body } = obj;
  scene = scene || 'p2p';
  if (type === 'text') {
    nim.sendRobotMsg({
      scene,
      to,
      robotAccid: robotAccid || to,
      content: {
        type: 'text',
        content
      },
      body,
      done: onSendMsgDone
    });
  } else if (type === 'welcome') {
    nim.sendRobotMsg({
      scene,
      to,
      robotAccid: robotAccid || to,
      content: {
        type: 'welcome'
      },
      body,
      done: onSendMsgDone
    });
  } else if (type === 'link') {
    nim.sendRobotMsg({
      scene,
      to,
      robotAccid: robotAccid || to,
      content: {
        type: 'link',
        params,
        target
      },
      body,
      done: onSendMsgDone
    });
  }
}

  // 发送消息已读回执
export function sendMsgReceipt({ state, commit }) {
    // 如果有当前会话
  const currSessionId = store.state.currSessionId;
  if (currSessionId) {
      // 只有点对点消息才发已读回执
    if (util.parseSession(currSessionId).scene === 'p2p') {
      const msgs = store.state.currSessionMsgs;
      const nim = state.nim;
      if (state.sessionMap[currSessionId]) {
        nim.sendMsgReceipt({
          msg: state.sessionMap[currSessionId].lastMsg,
          done: function sendMsgReceiptDone(error, obj) {
              // do something
          }
        });
      }
    }
  }
}

function sendMsgReceiptDone(error, obj) {
  console.log(`发送消息已读回执${!error ? '成功' : '失败'}`, error, obj);
}

export function getHistoryMsgs({ state, commit }, obj) {
  const nim = state.nim;
  if (nim) {
    const { scene, to } = obj;
    let options = {
      scene,
      to,
      reverse: false,
      asc: true,
      limit: config.localMsglimit || 20,
      done: function getHistoryMsgsDone(error, obj) {
        if (obj.msgs) {
          if (obj.msgs.length === 0) {
            commit('setNoMoreHistoryMsgs');
          } else {
            const msgs = obj.msgs.map((msg) => {
              return formatMsg(msg);
            });
            commit('updateCurrSessionMsgs', {
              type: 'concat',
              msgs
            });
          }
        }
        //store.dispatch('hideLoading');
      }
    };
    if (state.currSessionLastMsg) {
      options = Object.assign(options, {
        lastMsgId: state.currSessionLastMsg.idServer,
        endTime: state.currSessionLastMsg.time
      });
    }
    //store.dispatch('showLoading');
    nim.getHistoryMsgs(options);
  }
}

export function resetNoMoreHistoryMsgs({ commit }) {
  commit('resetNoMoreHistoryMsgs');
}

  // 继续与机器人会话交互
export function continueRobotMsg({ commit }, robotAccid) {
  commit('continueRobotMsg', robotAccid);
}



// WEBPACK FOOTER //
// ./src/store/nim/msgs.js